// extracted by mini-css-extract-plugin
export var lightMode = "_a-0";